import { Widget } from "blue-widgets";

class ErrorDialog extends Widget {
  constructor(el) {
    super(el);
    this.wrapper = this.el.querySelector("[data-wrapper]");
    this.closeBtns = this.el.querySelectorAll("[data-close-btn]");
    this.type = this.el.getAttribute("data-type");

    if (this.type === "sim-input") {
      this.simInput = document.querySelector(".simnumber");
    }

    // Native close() method on dialog element
    this.boundClose = this.el.close.bind(this.el);

    this.init();
  }

  dismiss = (e) => {
    if (e.target === this.el) this.boundClose();
  };

  // Prevent clicks on content in dialog from causing close()
  stopPropagation = (e) => {
    e.stopPropagation();
  };

  init() {
    this.el.addEventListener("click", this.dismiss);
    this.wrapper.addEventListener("click", this.stopPropagation);
    this.closeBtns.forEach((btn) => {
      btn.addEventListener("click", this.boundClose);
    });

    if (
      this.type === "sim-input" &&
      this.simInput.classList.contains("has-error")
    ) {
      this.el.showModal();
    }
  }

  beforeRemove() {
    this.el.removeEventListener("click", this.dismiss);
    this.wrapper.removeEventListener("click", this.stopPropagation);
    this.closeBtns.forEach((btn) => {
      btn.removeEventListener("click", this.boundClose);
    });
  }
}

export default ErrorDialog;
